import React from 'react';
const Invoice = () => <div className="p-8"><h1 className="text-2xl font-bold">Invoice Page</h1></div>;
export default Invoice; 